import { createContentPropTypes } from '../../../helpers/content';

const content = {
	AuthorisationTitle: 'Authorisation required',
	AuthorisationSubTitle: 'This will need authorised once you continue.',
	AuthorisationByUserSubTitle: 'This will need authorised by ',
	PaymentAuthorisation: 'This will need authorised once you continue',
	PaymentAuthorisationByNamed: 'This will need authorised by',
	PageHeader: 'Review',
	PageSubHeader: 'Please confirm the details you’ve entered are correct before you continue.',
	AuthorisationHeader: 'Authorisation required',
	AuthorisationBodyMsg:
		'Once you’ve confirmed the details are correct and you choose to continue, this payment will have to be authorised using one of our online security methods.',
	fromLabel: 'From',
	toLabel: 'To',
	amtLabel: 'Amount',
	refLabel: 'Reference',
	dateLabel: 'Date',
	typeLabel: 'Type',
	continueButtonText: 'Confirm and submit',
	importantInfoHeader: '<IndicativeHighlight.description>*Important information</IndicativeHighlight.description>',
	importantInfoText:
		'Your payment will be submitted using an indicative rate – this means the <IndicativeHighlight.description>figures highlighted are subject to change</IndicativeHighlight.description> until the payment is approved. The exact amounts will be clearly shown when it comes to authorising the payment.<p> </p><p>The settlement date has been estimated based on the payment being authorised by the cut-off time on the planned submission date.</p><p>Please note that any fees you’ve agreed to pay will be taken from your account as a separate payment.</p>',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
